import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {SettingsService} from 'src/app/services/settings.service';
import {StorageService} from 'src/app/services/storage.service';
import {
  createApprovalFlowStagesMutation,
  updateApprovalFlowStagesMutation
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.actions';
import {
  ApprovalFlowStages
} from 'src/app/store/entities/instution-settings/approval-flow-stages/approval-flow-stages.model';
import {getAllDesignations} from 'src/app/store/entities/instution-settings/designation/designation.actions';
import {Designation} from 'src/app/store/entities/instution-settings/designation/designation.model';
import {selectModifiedDesignation} from 'src/app/store/entities/instution-settings/designation/designation.selectors';
import {Institution} from 'src/app/store/entities/system-settings/institution/institution.model';
import {AppState} from 'src/app/store/reducers';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-add-approval-flow-stages-list',
  templateUrl: './add-approval-flow-stages-list.component.html',
  styleUrls: ['./add-approval-flow-stages-list.component.scss']
})
export class AddApprovalFlowStagesListComponent implements OnInit {

  title: string;
  approvalFlowStagesForm: FormGroup;

  hide: boolean = true;
  selectedData: ApprovalFlowStages;
  stageDesignation$:Observable<Designation []>;
  institution:Institution;
  flowUniqueId: string;

  stages: any

  constructor(
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) data :{stages:ApprovalFlowStages,flowUniqueId:string},
    private dialogRef: MatDialogRef<AddApprovalFlowStagesListComponent>,
    private fb: FormBuilder,
    private storageService: StorageService,

  ) {
    this.stages = data?.stages;
    this.flowUniqueId = data?.flowUniqueId;
  }


  ngOnInit(): void {
    this.title = "Add Stage"
    this.institution = this.storageService.getItem('institution');
    this.store.dispatch(getAllDesignations({institutionUniqueId:this.institution?.institutionUniqueId}))

    this.stageDesignation$ = this.store.select(selectModifiedDesignation)

    this.approvalFlowStagesForm = this.fb.group({
      stageName: [null, Validators.required],
      stageIsStarting: [false],
      stageIsEnding: [false],
      stageFlow: [this.flowUniqueId,Validators.required],
      stageDesignation:[null,Validators.required]

    });


    if (this.stages) {
      this.approvalFlowStagesForm.patchValue({
        ...this.stages,
        stageDesignation:this.stages?.stageDesignation?.designationUniqueId
      });
    }

  }


  closeModal(close: boolean): void {
    if (close) {
      this.dialogRef.close();
    }
  }

  submitForm(formValue: { stageName: string,stageIsStarting:string,stageIsEnding:string,stageFlow:string}) {
    this.stages ? this.store.dispatch(updateApprovalFlowStagesMutation({
      stage: {
          ...formValue,
          stageUniqueId: this.stages.stageUniqueId
        }
      })) :
      this.store.dispatch(createApprovalFlowStagesMutation({
        stage: formValue
      }))
    this.closeModal(true)

}

}
